import { Form, Input, Select,DatePicker } from "antd";
import dayjs from "dayjs";
import React from "react";
// import DatePicker from "../datapicker";
import { FilterItemProps } from "./interface";

const { RangePicker } = DatePicker;

const ItermRender: React.FC<FilterItemProps> = (props: FilterItemProps) => {
  if (props.type === "text") {
    return <TextRenderer {...props} />;
  }

  if (props.type === "timeRange") {
    return <TimeRangeRenderer {...props} />;
  }

  if (props.type === "select") {
    return <SelectRenderer {...props} />;
  }

  return <></>;
};

export default ItermRender;

const TextRenderer: React.FC<FilterItemProps> = ({ label, name, pattern }) => {
  let rules = [];
  if (pattern !== undefined) {
    rules.push({
      pattern: pattern.rule,
      message: pattern.message,
    });
  }

  return (
    <Form.Item label={label} name={name} rules={rules}>
      <Input />
    </Form.Item>
  );
};

const TimeRangeRenderer: React.FC<FilterItemProps> = ({
  label,
  name,
  pattern,
}) => {
  let rules = [];
  if (pattern !== undefined) {
    rules.push({
      pattern: pattern.rule,
      message: pattern.message,
    });
  }

  return (
    <Form.Item label={label} name={name} rules={rules}>
      <RangePicker
      style={{width:"100%"}}
        ranges={{
          上月: [
            dayjs()
              .startOf("month")
              .subtract(1, "day")
              .startOf("month"),
            dayjs()
              .startOf("month")
              .subtract(1, "month")
              .endOf("month"),
          ],
          本月: [dayjs().startOf("month"), dayjs()],
          本周: [dayjs().startOf("week"), dayjs()],
          昨天: [
            dayjs().startOf("day").subtract(1, "day").startOf("day"),
            dayjs().startOf("day").subtract(1, "second"),
          ],
          今天: [dayjs().startOf("day"), dayjs()],
        }} />
    </Form.Item>
  );
};

const SelectRenderer: React.FC<FilterItemProps> = ({
  label,
  name,
  pattern,
  options,
  onSubmit
}) => {
  let rules = [];
  if (pattern !== undefined) {
    rules.push({
      pattern: pattern.rule,
      message: pattern.message,
    });
  }

  return (
    <Form.Item label={label} name={name} rules={rules}>
      <Select onChange={onSubmit}>
        {options?.map((o, i) => (
          <Select.Option key={i} value={o.value}>
            {o.label}
          </Select.Option>
        ))}
      </Select>
    </Form.Item>
  );
};
